import React from "react";
import { bool } from "prop-types";
import Icon from "../Icon";
import Inline from "../Inline";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { colorPropTypes } from "../props/sx";

const DropdownTriangle = ({ isOpen, isOpenColor, color, size, spacing }) => {
	return (
		<Inline className="dropdown-title__triangle">
			<Icon
				name={isOpen ? "angle-up" : "angle-down"}
				spacing={deepMergeProps({ m: 0 }, pureProps(spacing))}
				color={isOpen ? isOpenColor : color}
				size={size}
			/>
		</Inline>
	);
};

const { name, ...IconPropTypes } = Icon.propTypes;

DropdownTriangle.propTypes = {
	isOpen: bool,
	isOpenColor: colorPropTypes,
	...IconPropTypes,
};

export default DropdownTriangle;
